import React, { useEffect } from 'react';
import '../styles/CustomCursor.css'; // Ensure this includes the cursor styles

const CustomCursor = () => {
    useEffect(() => {
        const cursorDot = document.querySelector("[data-cursor-dot]");

        const cursorOutline = document.querySelector("[data-cursor-outline]");
        // const updateCursorColors = () => {
        //     const dotColor = isOverlayActive
        //         ? (isDarkTheme ? "#ffffff" : "#000000") // Lighter in overlay
        //         : (isDarkTheme ? "#ffffff" : "#121212"); // Switch for general theme
        //     const outlineColor = isOverlayActive
        //         ? (isDarkTheme ? "rgba(255, 255, 255, 0.5)" : "rgba(0, 0, 0, 0.5)")
        //         : (isDarkTheme ? "rgba(255, 255, 255, 0.5)" : "rgba(0, 0, 0, 0.5)");
        //
        //     // Apply dynamic colors
        //     if (cursorDot) cursorDot.style.backgroundColor = dotColor;
        //     if (cursorOutline) cursorOutline.style.borderColor = outlineColor;
        // };

        const handleMouseMove = (e) => {
            const posX = e.clientX;
            const posY = e.clientY;

            if (cursorDot) {
                // Update dot position
                cursorDot.style.left = `${posX}px`;
                cursorDot.style.top = `${posY}px`;
            }
            if (cursorOutline) {
            // Update outline position with animation
            cursorOutline.style.left = `${posX}px`;
            cursorOutline.style.top = `${posY}px`;

            cursorOutline.animate(
                {
                    left: `${posX}px`,
                    top: `${posY}px`,
                },
                { duration: 500, delay: 5, fill: "forwards" }
            );
        }
            };
    // };updateCursorColors();isDarkTheme, isOverlayActive
        // Add event listener
        window.addEventListener("mousemove", handleMouseMove);

        return () => {
            // Clean up the event listener
            window.removeEventListener("mousemove", handleMouseMove);
        };
    }, []);


    return (
        <>
            <div className="cursor-dot" data-cursor-dot></div>
            <div className="cursor-outline" data-cursor-outline></div>
        </>
    );
// null; // This component only handles the logic, no rendering
};

export default CustomCursor;